import { render } from "./TotalSheet.vue?vue&type=template&id=a3f4b7f6"
import script from "./TotalSheet.vue?vue&type=script&lang=js"
export * from "./TotalSheet.vue?vue&type=script&lang=js"

import "./TotalSheet.vue?vue&type=style&index=0&id=a3f4b7f6&lang=scss"
script.render = render

export default script